import React from 'react'
import styled from '@emotion/styled'
import { Grid } from '@mui/material'
import { Colors, Shapes } from 'src/components/theme'
import { useRecoilValue } from 'recoil'
import { rgbaStrOpacity } from 'src/utils/colors'
import * as atomsColors from 'src/atoms/colors'

type InsightCardGridCellProp = {
  last?: boolean
  hPadding?: number
  noBorder?: boolean
  roundTop?: boolean
  roundBottom?: boolean
  children?: React.ReactNode
}

type InsightCardGridCellColoredProp = InsightCardGridCellProp & {
  compare?: boolean
  index: number
}

export const InsightCardGrid = styled((props: any) => <Grid {...props} />)`
  display: flex;
  position: relative;
  align-items: center;
  padding-top: 0px !important;
  margin-top: 0px !important;
  flex-grow: 1;
`

export const InsightCardGridCell = styled.div<InsightCardGridCellProp>`
  display: block;
  width: 100%;
  height: 40px;
  padding: ${Shapes.spacing[3]}px ${(props) => Shapes.spacing[props.hPadding ? props.hPadding : 3]}px;
  border-bottom: ${(props) => (props.last || props.noBorder ? 'none' : `1px solid ${Colors.border}`)};
  border-top-left-radius: ${(props) => (props.roundTop ? Shapes.borderRadius : 0)}px;
  border-top-right-radius: ${(props) => (props.roundTop ? Shapes.borderRadius : 0)}px;
  border-bottom-right-radius: ${(props) => (props.roundBottom ? Shapes.borderRadius : 0)}px;
  border-bottom-left-radius: ${(props) => (props.roundBottom ? Shapes.borderRadius : 0)}px;

  & > p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
export const InsightCardGridCellColored = (props: InsightCardGridCellColoredProp) => {
  const { index, compare } = props
  const gradientsColors = useRecoilValue(atomsColors.gradientsColors)
  const gradientsTopColors = useRecoilValue(atomsColors.gradientsTopColors)
  const color = compare ? gradientsTopColors[index] : gradientsColors[0][index]
  const background = rgbaStrOpacity(color, 0.15)

  return <InsightCardGridCell style={{ backgroundColor: background }} {...props} />
}
